<v-text-field :label="label" :type="type" :solo="solo"></v-text-field>